import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

import { ActivableCardComponent } from './activable-card/activable-card.component';
import { ActivableCardGroupDirective } from './activable-card/activable-card-group';
import { FullscreenComponent } from './fullscreen/fullscreen.component';
import { MaterialModule } from './material.module';
import { SearchBarComponent } from './search-bar/search-bar.component';
import { SidebarComponent } from './sidebar/sidebar.component';
import { SidemenuComponent } from './sidemenu/sidemenu.component';
import { SidemenuItemComponent } from './sidemenu-item/sidemenu-item.component';
import { ToolbarComponent } from './toolbar/toolbar.component';
import { UserMenuComponent } from './user-menu/user-menu.component';
import { DirectivesModule } from '../directives/directives.module';
import { PipesModule } from '../pipes/pipes.module';
import { environment } from '../../environments/environment';

import { MessageService } from '@cube/lib-common';
import { LoggerModule } from 'ngx-logger';
import { MomentModule } from 'ngx-moment';
import {
  PerfectScrollbarModule,
  PERFECT_SCROLLBAR_CONFIG,
  PerfectScrollbarConfigInterface,
} from 'ngx-perfect-scrollbar-portable';

import { TranslateModule } from '@ngx-translate/core';
import { LetDirective, PushPipe } from '@ngrx/component';

const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
  suppressScrollX: true,
};

@NgModule({
  declarations: [
    ActivableCardComponent,
    ActivableCardGroupDirective,
    FullscreenComponent,
    SearchBarComponent,
    SidebarComponent,
    SidemenuComponent,
    SidemenuItemComponent,
    ToolbarComponent,
    UserMenuComponent,
  ],
  imports: [
    CommonModule,
    DirectivesModule,
    FormsModule,
    LetDirective,
    LoggerModule.forRoot(environment.logger),
    MaterialModule,
    MomentModule,
    PerfectScrollbarModule,
    PipesModule,
    PushPipe,
    ReactiveFormsModule,
    RouterModule,
    TranslateModule,
  ],
  exports: [
    ActivableCardComponent,
    ActivableCardGroupDirective,
    FormsModule,
    FullscreenComponent,
    LetDirective,
    MaterialModule,
    PushPipe,
    ReactiveFormsModule,
    RouterModule,
    SearchBarComponent,
    SidebarComponent,
    SidemenuComponent,
    SidemenuItemComponent,
    ToolbarComponent,
    TranslateModule,
    UserMenuComponent,
  ],
  providers: [
    MessageService,
    {
      provide: PERFECT_SCROLLBAR_CONFIG,
      useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG,
    },
  ],
})
export class CoreModule {}
